import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeColor, Flex, Copy } from '@elparking/components'

import PriceContainer from '../PriceContainer'

const boxShadow = ({ isSelected }) => isSelected ? '0 2px 8px 0 rgba(0,0,0,0.1)' : 'none'
const borderWidth = ({ isSelected }) => isSelected ? '2px' : '1px'
const borderColor = ({ isSelected }) => isSelected ? themeColor('main') : themeColor('gray20')
const hoverBorderColor = ({ isDisabled }) => !isDisabled ? themeColor('main') : themeColor('gray20')

const Card = styled(Flex)`
    background-color: ${themeColor('white')};
    border: ${borderWidth} solid ${borderColor};
    border-radius: 2px;
    padding: 1em;
    box-shadow: ${boxShadow};
    transition: border-color 0.25s;
    min-width: 0;
    cursor: pointer;
    &:hover {
        border-color: ${hoverBorderColor};
    }
`

function VehicleInspectionProduct ({product, isSelected}) {
    return (
        <Card flexDirection='column' isSelected={isSelected} dataTest='itv-card'>
            <PriceContainer
              originalPrice={product.originalPrice}
              totalPrice={product.totalPrice}
            />
            <Copy.truncate padding='4px 0 0 0' fontSize='medium' fontWeight='medium'>
                {product.name}
            </Copy.truncate>
            <Copy.clamp padding='4px 0 0 0' fontSize='small' fontWeight='regular' lines='2'>
                {product.description}
            </Copy.clamp>
        </Card>
    )
}

VehicleInspectionProduct.propTypes = {
    product: PropTypes.object,
    isSelected: PropTypes.bool,
}

export default VehicleInspectionProduct
